import { memo, useEffect, useState } from 'react';

import { Markdown } from '@/shared/ui/markdown';

export const MessageWithDelay = memo(
  ({
    text,
    delay,
    withMarkdown,
    className,
  }: {
    text: string | null | undefined;
    delay: number;
    withMarkdown?: boolean;
    className?: string;
  }) => {
    const safeText = text ?? '';
    const [displayedText, setDisplayedText] = useState('');
    const [currentCharIndex, setCurrentCharIndex] = useState(0);

    useEffect(() => {
      setDisplayedText('');
      setCurrentCharIndex(0);
    }, [safeText]);

    useEffect(() => {
      if (currentCharIndex >= safeText.length) return;

      const interval = setInterval(() => {
        setDisplayedText((prev) => prev + safeText[currentCharIndex]);
        setCurrentCharIndex((prevIndex) => prevIndex + 1);

        if (currentCharIndex + 1 >= safeText.length) {
          clearInterval(interval);
        }
      }, delay);

      return () => clearInterval(interval);
    }, [safeText, delay, currentCharIndex]);

    return withMarkdown ? (
      <div className={`markdown-content ${className}`}>
        <Markdown className={className}>{displayedText}</Markdown>
      </div>
    ) : (
      <>{displayedText}</>
    );
  },
);
